import { render, staticRenderFns } from "./TabPersetujuanRanap.vue?vue&type=template&id=851f4506&scoped=true&"
import script from "./TabPersetujuanRanap.vue?vue&type=script&lang=ts&"
export * from "./TabPersetujuanRanap.vue?vue&type=script&lang=ts&"
import style0 from "./TabPersetujuanRanap.vue?vue&type=style&index=0&id=851f4506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851f4506",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VDivider,VTab,VTabItem,VTabs})
